import Cookies from 'universal-cookie';

/**
 * For prefilling apply details and stroring apply related information in cookie/localstorage
 */
export default class ApplyCookieHelper {

  constructor() {
    this.cookies = new Cookies();
  }


  //Get applied jobs from cookie
  getAppliedJobs() {
    let jobsApplied = this.cookies.get('jobs_applied');
    return jobsApplied ? jobsApplied.split(',') : [];
  }

  /**
   * Is Job Already Applied and Added to applied cookie list
   * @param {*} jobId
  */
  isJobApplied(jobId) {
    let appliedJobs = this.getAppliedJobs();
    if (appliedJobs && jobId) {
      if (appliedJobs.indexOf(jobId.toString()) > -1) {
        return true;
      }
    }
    return false;
  }

  //Add job id to applied job list
  setAppliedJob(jobId) {
    let appliedJobs = this.getAppliedJobs();
    if (appliedJobs.indexOf(jobId.toString()) < 0) {
      appliedJobs.push(jobId);
      this.cookies.set('jobs_applied', appliedJobs.join(','), { path: '/' });
    }
  }

  setAppliedJobs(appliedJobs) {
    // appliedJobs should be an array of jobs ids
    this.cookies.set('jobs_applied', appliedJobs.join(','), { path: '/' });
  }

  getPrefillItem(key) {
    let item = this.cookies.get('jobs_var_' + key);
    return item;
  }

  setPrefillItem(key, value) {
    if (key === 'email') {
      // Compatibility with old code
      key = 'email_Id';
    }

    if (value && typeof value !== 'undefined') {
      this.cookies.set('jobs_var_' + key, value, { path: '/' });
    }
  }

  getPreferredCity() {
    return this.cookies.get('new_prefer_city');
  }

  getPreferredCityId() {
    return this.cookies.get('new_prefer_city_id');
  }

  getPreferredRole() {
    return this.cookies.get('new_prefer_role');
  }

  setPreferredRole(role) {
    if (('' !== role) && ('undefined' !== typeof role)) {
      this.cookies.set('new_prefer_role', role, { path: '/' });
    }
  }

  getABRand = () => parseInt(this.cookies.get('abRand'), 10);

  getABRandMobile = () => parseInt(this.cookies.get('abRandMobile'), 10);

  checkProfileCookieDataForLoggedOutUser() {
    if (
      this.getPrefillItem('city') && this.getPrefillItem('email_Id') &&
      this.getPrefillItem('locality') && this.getPrefillItem('mobile') &&
      this.getPrefillItem('name')) {
      return true;
    } else {
      return false;
    }
  }

  updateCookiesAfterApplyWithoutEmail() {
    this.cookies.set('jobs_var_email_Id', '', { path: '/', expires: new Date(0) });
  }
}



// WEBPACK FOOTER //
// ../q-jobs/src/utils/Apply/ApplyCookieHelper.js